import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import { BasicPage } from "../../theme/Component/BasicPage";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AccountantConcept, _FiscalResponsability, _FiscalResponsabilityType, _single } from "../../../core/services/dataBean/EntityCatalog";
import {  _Project } from "../../../core/services/dataBean/EntityCatalogVdos";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../theme/Component/hooks/useModal";
import { InputDate } from "../../theme/Input/InputDate";
import { AccountEditor } from "../../editor/AccountEditor";
import { AdquisitionBeneficiary } from "../AdquisitionBeneficiary/AdquisitionBeneficiary";
import { PaymentMethodSelect } from "../../Talentohumano/PaymentMethod/PaymentMethodSelect";
import { ManagementTypeSelect } from "./ManagementTypeSlector";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { SelectProjectID } from "../../admin/configuracion/ProjectID/SelectProjectID";
import { ProjectSchedule } from "../ProjectSchedule/ProjectSchedule";
import { SelectBusinessCore } from "../cellEditor/BusinessCore/SelectBusinessCore";
import { AgreementSelect } from "../cellEditor/AgreementClassification/AgreementSelect";
import { BusinesTypeSelect } from "../cellEditor/BusinessType/BusinesTypeSelect";
import { AgreementBalance } from "../AgreementBalance/AgreementBalance";
import { ProjectProducts } from "./ProjectProducts/ProjectProducts";
import { ResumeContract } from "../../contract/etapa-contrato/contrac/ResumeContract";
import { SelectProject } from "../cellEditor/BudgetAccountantOperation/SelectProject";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicButton } from "../../theme/Component/BasicButton";
import { AdquisitionProjectLines } from "./AdquisitionProjectLines";
import { CDPInfo } from "./ProjectProducts/CDPInfo";
import { EditorExpedientDocumentFile } from "../../DocumentManagement/Management/DocumentFileManager/EditorExpedientDocumentFile";


export const AdquisitionProject = () => {

    const Project = useDataBean(_Project);
    const [lista, setLista] = useState<any>([]);
    const [balance, setBalance] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [swich, setSwich] = useState<boolean>(null)
    const modalConfirm = useModal("Orden", MODAL_SM);
    const modalEditar = useModal("Agregar Proyecto", MODAL_LG);
    const modalProduct = useModal(`Lista de Productos de ${Project.bean.Name}`, MODAL_md);
    const modalResumenContrato = useModal("Resumen", MODAL_XL);
    const modalLieasPlan = useModal("Lineas PAA", MODAL_XL);
    const modalExpe = useModal("Expediente del Proyecto", MODAL_LG);
    const cdpInfo = useModal("Información CDP", MODAL_LG);
    const [filter, setFilter] = useState<any>({
        State: 1
    });
    const paginador = usePaginator();



    useEffect(() => {
        getLista()

    }, [paginador.page])


    const getLista = () => {

        let tmp = _single.cleanMap(filter);

        Project.instance.getProjectRender(paginador.page, 15, tmp).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp.List);
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15);
                }
            }
        )

    }

    const create = () => {
        Project.setBean({
            State: 1,
            IDEmployee: _single.getAccountID()
        });
        setSwich(false);
        modalEditar.setModal({ ...modalEditar.modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);
        Project.update().then(
            (resp: any) => {
                getLista();
                modalEditar.setModal({ ...modalEditar.modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        Project.bean.State = 2;
        //console.log(Project.bean); 
        editaItem();
        modalConfirm.close();
    }
//head
    const head = [
        { title: 'ID', property: 'IDProject', visible: true, mask: MASK_NUMBER },
        { title: 'Código Proyecto', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Nit', property: 'Nit', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Inicial', property: 'InitDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Final', property: 'UptoDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Modificación', property: 'UptoDateAgreementBalance', visible: true, mask: MASK_DATE },
        { title: 'Tercero', property: 'EntityName', visible: true },
        { title: 'Valor Convenio', property: 'TotalValue', visible: true, mask: MASK_MONEY },
        { title: 'Maximo Contratación', property: 'MaxAmmount', visible: true, mask: MASK_MONEY },
        { title: 'TotalPAA', property: 'TotalPAA', visible: true, mask: MASK_MONEY },
        { title: 'TotalPF', property: 'TotalPF', visible: true, mask: MASK_MONEY },
        { title: 'Disponible', property: 'Disponible', visible: true, mask: MASK_MONEY },
        { title: 'Objeto', property: 'ObjectText', visible: false },        
        { title: 'Clasificacion de Convenio', property: 'IDAgreementClassificationName', visible: false },
        { title: 'Iniciativa Estrategica', property: 'IDLnProjectIDName', visible: false },
        { title: 'Tipo de Negocio', property: 'IDBusinessTypeName', visible: false },
        { title: 'Convenio Liquidado?', property: 'IsSettlement', visible: false },
        { title: 'Fecha de Liquidacion', property: 'SettlementDate', visible: false },
        { title: 'Descripción', property: 'Description', visible: false },
        { title: '%', property: 'AdminFee', visible: true, mask: MASK_NUMBER },
        { title: 'Metodo de pago', property: 'IDPaymentMethodName', visible: false },
        { title: 'RP Externo', property: 'ExternalRP', visible: false, mask: MASK_DATE },
        { title: 'Fecha RP Externo', property: 'ExternalRPDate', visible: false, mask: MASK_DATE },
        { title: 'Proyecto Padre', property: 'ProjectPhater', visible: false }
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEditar.setModal({ ...modalEditar.modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Beneficiarios', icono: 'ri-team-line', visible: _single.canDelete(), evento: () => { setbeneficiario({ ...beneficiario, "view": true }) } },
            { titulo: 'Cronograma', icono: 'ri-timer-line', visible: _single.canDelete(), evento: () => { setcronograma({ ...cronograma, "view": true }) } },
            { titulo: 'Modificaciones de proyecto', icono: 'ri-file-edit-line', visible: _single.canDelete(), evento: () => { setBalance({ ...balance, "view": true }) } },
            { titulo: 'Lineas PAA', icono: 'ri-file-zip-line', visible: _single.canCreate(), evento: () => { modalLieasPlan.open() } },
            { titulo: 'Expediente', icono: 'ri-file-zip-line', visible: _single.canCreate(), evento: () => { modalExpe.open() } },
            { titulo: 'Ejecución', icono: 'ri-list-check-2', visible: true, evento: () => { modalResumenContrato.open() } },
            { titulo: 'Información CDP', icono: 'ri-file-text-line', visible: true, evento: () => { cdpInfo.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <BasicPage titulo="Catálogo de Proyectos">
            <div className="row">
                <div className="col-md-12">
                    <Modal modal={balance} updateModal={setBalance} evenOnClose={getLista}>
                        <>
                            <AgreementBalance IDProject={Project.bean.IDProject} />
                        </>
                    </Modal>
                    <Modal modal={modalResumenContrato.modal} updateModal={modalResumenContrato.setModal} >
                        <ResumeContract nameProp="IDProject" props={Project.bean} />
                    </Modal>
                    <Modal modal={modalLieasPlan.modal} updateModal={modalLieasPlan.setModal} >
                        <AdquisitionProjectLines idProject={Project.bean.IDProject} />
                    </Modal>
                </div>
                <div className="col-md-12">
                    <div className="row">
                        {/* <div className="col-md-3">
                            <label>Código Convenio</label>
                            <input type="text" name="code" className="form-control" value={filter.Code} onChange={(e)=>{setFilter({...filter,"Code":e.target.value})}}/>
                        </div> */}
                        <div className="col-md-4">
                            <SelectProject label="Proyecto" idSelector={filter.IDProject} onChange={(e) => { setFilter({ ...filter, "IDProject": e }) }} returnType="ID" />
                        </div>
                        <div className="col-md-4">
                            <AccountEditor label="Tercero" idAccount={filter.IDAccount} onChange={(e) => { setFilter({ ...filter, "IDAccount": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-12 mt-3">
                            <BasicButton icon="" eventClick={getLista}>Buscar</BasicButton>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={Project.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}
                        next={paginador.next}
                        pageTop={paginador.page}
                        back={paginador.back}
                        records={paginador}
                    ></BasicTable>
                    <Modal modal={cdpInfo.modal} updateModal={cdpInfo.setModal} >
                        <CDPInfo Project={Project.bean} />
                    </Modal>
                    <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <ManagementTypeSelect idSelector={Project.bean.ManagementType} onChange={(e) => { Project.setBean({ ...Project.bean, "ManagementType": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Nombre</label>
                                    <input type="text" name="Name" className="form-control" value={Project.bean.Name} onChange={Project.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>Código Proyecto</label>
                                    <input type="text" name="Code" className="form-control" value={Project.bean.Code} onChange={(e) => { Project.setBean({ ...Project.bean, "Code": e.target.value }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Valor</label>
                                    <input type="text" name="TotalValue" className="form-control" value={Project.bean.TotalValue} onChange={Project.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label>RP Externo</label>
                                    <input type="text" name="ExternalRP" className="form-control" 
                                    value={Project.bean.ExternalRP} onChange={Project.handleChange} />
                                </div>
                                <div className="col-md-6">                                    
                                    <InputDate notDate label="Fecha RP Externo" name="ExternalRPDate" 
                                    value={Project.bean.ExternalRPDate} setDate={(e) => { Project.setBean({ ...Project.bean, "ExternalRPDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Fecha Inicial" name="InitDate" value={Project.bean.InitDate} setDate={(e) => { Project.setBean({ ...Project.bean, "InitDate": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <InputDate notDate label="Fecha Final" name="UptoDate" value={Project.bean.UptoDate} setDate={(e) => { Project.setBean({ ...Project.bean, "UptoDate": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <AccountEditor label="Tercero" idAccount={Project.bean.IDAccount} onChange={(e: any) => { Project.setBean({ ...Project.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                                </div>

                                <div className="col-md-12">
                                    <label>Objeto</label>
                                    <textarea name="ObjectText" className="form-control" value={Project.bean.ObjectText} onChange={Project.handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <SelectBusinessCore label='Línea de Negocio' returnType="Object" idSelector={Project.bean.IDBusinessCore} onChange={(e) => { Project.setBean({ ...Project.bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                                </div>
                                <div className="col-md-6">
                                    <AgreementSelect idSelector={Project.bean.IDAgreementClassification} onChange={(e) => { Project.setBean({ ...Project.bean, "IDAgreementClassification": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BusinesTypeSelect idSelector={Project.bean.IDBusinessType} onChange={(e) => { Project.setBean({ ...Project.bean, "IDBusinessType": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <label>Codigo BPin</label>
                                    <input type="number" name="BPINCode" className="form-control" value={Project.bean.BpinCode} onChange={(e) => { Project.setBean({ ...Project.bean, "BpinCode": parseInt(e.target.value) }) }} />
                                </div>


                                <div className="col-md-12">
                                    <label>Descripción</label>
                                    <textarea name="Description" className="form-control" value={Project.bean.Description} onChange={Project.handleChange} />
                                </div>

                                <div className="col-md-6">
                                    <label>Porcentaje de Administración</label>
                                    <input type="number" name="AdminFee" className="form-control" value={Project.bean.AdminFee} onChange={Project.handleChange} />
                                </div>
                                <div className="col-6">
                                    <PaymentMethodSelect idSelector={Project.bean.IDPaymentMethod} onChange={(e) => { Project.setBean({ ...Project.bean, "IDPaymentMethod": e }) }} />
                                </div>
                                <div className="col-md-12">
                                    <SelectProjectID projectIDLn={Project.bean.IDLnProjectID} edit={false} onChange={(e: any) => { Project.setBean({ ...Project.bean, "IDLnProjectID": e.IDLn }) }} />
                                </div>
                                <div className="col-md-12">
                                    <hr />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch label="Convenio Liquidado ?" estado={Project.bean.IsSettlement} eventChange={(e: any) => { Project.setBean({ ...Project.bean, "IsSettlement": e }) }}></BasicSwitch>
                                </div>
                                {Project.bean.IsSettlement &&
                                    <>
                                        <div className="col-md-6">
                                            <InputDate notDate label="Fecha de Liquidacion*" name="SettlementDate" value={Project.bean.SettlementDate} setDate={(e) => { Project.setBean({ ...Project.bean, "SettlementDate": e }) }} />
                                        </div>
                                    </>
                                }

                                <div className="col-md-12">
                                    <hr />
                                </div>
                                <div className="col-md-12 ">
                                    <label>Agregar Proyecto Padre ?</label>
                                    <BasicSwitch estado={swich} eventChange={(e) => { setSwich(e) }} />

                                </div>
                                {swich && (
                                    <div className="col-md-6">
                                        <SelectProject
                                            label="Proyecto padre"
                                            idSelector={Project.bean.IDAdquisitionProjectFather}
                                            onChange={(e) => {
                                                Project.setBean({
                                                    ...Project.bean,
                                                    "IDAdquisitionProjectFather": e
                                                })
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    </Modal>
                    <Modal modal={beneficiario} updateModal={setbeneficiario} >
                        <>
                            <AdquisitionBeneficiary IDProject={Project.bean.IDProject} />

                        </>
                    </Modal>

                    <Modal modal={cronograma} updateModal={setcronograma} >
                        <>

                            <ProjectSchedule IDProject={Project.bean.IDProject} />
                        </>
                    </Modal>

                    <Modal modal={cronograma} updateModal={setcronograma} >
                        <>

                            <ProjectSchedule IDProject={Project.bean.IDProject} />
                        </>
                    </Modal>

                    <Modal modal={modalProduct.modal} updateModal={modalProduct.setModal} >
                        <ProjectProducts _IDProject={Project.bean.IDProject} />
                    </Modal>

                    <Modal modal={modalExpe.modal} updateModal={modalExpe.setModal}>
                        <EditorExpedientDocumentFile _ClassForName="com.orange.bean.Project" _IDClass={Project.bean.IDProject} />
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}